// Styles
import "./compact-text-input.scss";
// Tools
import { useState, type KeyboardEvent } from "react";

interface Props {
	value: string;
	actionInput: (value: string) => void;
	placeholder?: string;
	className?: string;
	onKeyDown?: (event: KeyboardEvent<HTMLInputElement>) => void;
}

export const CompactTextInput = ({
	value,
	actionInput,
	placeholder,
	className,
	onKeyDown,
}: Props) => {
	const [focusStatus, setFocusStatus] = useState<boolean>(false);

	return (
		<div className={`compact-text-input ${className ? className : ""}`}>
			<div
				className={`compact-text-input__wrapper ${focusStatus ? "focus" : ""}`}>
				<input
					value={value}
					placeholder={placeholder}
					onFocus={() => setFocusStatus(true)}
					onBlur={() => setFocusStatus(false)}
					onChange={(event) => actionInput(event.target.value)}
					onKeyDown={onKeyDown}
					type='text'
				/>
				<button
					onClick={() => actionInput("")}
					className='compact-text-input__close-button'>
					<img src='/img/icons/close.png' alt='' />
				</button>
			</div>
		</div>
	);
};
